export const ErrorBanner = ({ children }: { children: React.ReactNode }) => (
  <div
    role="alert"
    className="flex items-center gap-2 rounded-[0.6rem] border border-brand-danger/25 bg-brand-danger/10 px-4 py-3 text-sm text-brand-danger"
  >
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="shrink-0">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
    {children}
  </div>
);
